import { useState } from 'react';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

import moment from 'moment';
import * as XLSX from 'xlsx';

const useUploadFileLocationHook = ({
    deleteTableExcel,
    setVisibleExcel,
    fileInputRef,
    departments,
    t,
    infoGroup,
    dataLengthRef,
    idGroup,
}) => {
    const [dataExcel, setDataExcel] = useState([]);
    const [checkDataExcel, setCheckDataExcel] = useState(false);
    // import properties group
    const handleFileUploadLocationDeviceProperty = (event) => {
        setDataExcel([]);
        deleteTableExcel();
        if (event.target.files?.length > 0) {
            setCheckDataExcel(true);
            const file = fileInputRef.current.files[0];
            try {
                const reader = new FileReader();

                reader.onload = (e) => {
                    const data = new Uint8Array(e.target.result);
                    const workbook = XLSX.read(data, { type: 'array' });
                    if (workbook.SheetNames?.length > 0) {
                        // Lấy dữ liệu từ sheet đầu tiên
                        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
                        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                        const listImportTempExcel = [];
                            console.log(jsonData)
                        if (jsonData?.length > 0) {
                            jsonData.map((user, idx) => {
                                const note = [];
                                if(user.length == 0){
                                    return
                                }
                                if (user.length < 16) {
                                    user = [...user, ...Array(16 - user.length).fill(null)];
                                }
                                const old_device_cd = user[0];
                                const new_device_cd = user[1];
                                const device_nm = user[2];
                                const name_supplier = user[3];
                                const producer = user[4];
                                const list_depart = user[5];
                                const price = Number(user[6]);
                                const status_device = user[7];
                                const checking_after = user[8];
                                const can_grinding = user[9];
                                const old_cabinet_cd = user[10];
                                const old_drawer_lc = user[11];
                                const old_cell = user[12];
                                const new_cabinet_cd = user[13];
                                const new_drawer_lc = user[14];
                                const new_cell = user[15];

                                const arrProperties = [];
                                if (idx !== 0)
                                    if (user?.length > 15) {
                                        const arrDepartments = [];
                                        const departmentExcel = list_depart
                                            ?.split(',')
                                            .map((item) => item.trim())
                                            .filter((ele) => ele.length > 0) || [];
                                        if (departmentExcel?.length > 0) {
                                            departmentExcel.forEach((item) => {
                                                const matchedItem = departments.find((obj) => obj.depart_cd === item);
                                                if (matchedItem) {
                                                    arrDepartments.push({
                                                        label: matchedItem.departs_nm,
                                                        value: matchedItem.depart_cd,
                                                    });
                                                } else {
                                                    note.push(t('not_found_department') + ` ${item}. `);
                                                }
                                            });
                                        }

                                        if (user?.length > 15) {
                                            user.map((properties, index) => {
                                                if (index > 15) {
                                                    arrProperties.push({
                                                        label: jsonData[0][index],
                                                        value: `${properties}`,
                                                    });
                                                }
                                            });
                                        }

                                        const extractNumbers = (input) => {
                                            if (
                                                typeof input === 'string' &&
                                                input.trim().match(/^\[\s*(\d+)\s*:\s*(\d+)\s*\]$/)
                                            ) {
                                                // Nếu input là chuỗi và có định dạng [ number : number ]
                                                // const sliceStr = input.trim().slice(1, -1).trim().replace(/\s+/g, '').split(':');
                                                const regex = /\d+/g;
                                                const matches = input.match(regex);
                                                if (matches) {
                                                    return { row: Number(matches[0]), column: Number(matches[1]) };
                                                }
                                            } else if (typeof input === 'number') {
                                                // Nếu input là số
                                                return { row: 1, column: input };
                                            }
                                            toast.error(t('data_file_err_cells'));
                                            return null;
                                        };

                                        if (!old_cabinet_cd) {
                                            note.push(t('not_found_cabinet_old') + `. `);
                                        }

                                        if (!old_drawer_lc) {
                                            note.push(t('not_found_drawer_old') + `. `);
                                        }

                                        if (!old_cell) {
                                            note.push(t('not_found_cell_old') + `. `);
                                        }

                                        const fields = ['cabinet_cd', 'drawer_lc', 'cell'];
                                        let differences = 0;
                                        fields.forEach((f) => {
                                            const oldVar = eval(
                                                `typeof old_${f} !== 'undefined' ? old_${f} : undefined`
                                            );
                                            const newVar = eval(
                                                `typeof new_${f} !== 'undefined' ? new_${f} : undefined`
                                            );

                                            if (oldVar === undefined || newVar === undefined) {
                                                console.log(`${f}: FIELD NOT FOUND (old=${oldVar}, new=${newVar})`);
                                            } else if (oldVar === newVar) {
                                                console.log(`${f}: SAME (${oldVar})`);
                                            } else {
                                                differences += 1;
                                                console.log(`${f}: differences (old=${oldVar}, new=${newVar})`);
                                            }
                                        });

                                        let cell_lc_nums_new = extractNumbers(new_cell);
                                        if (cell_lc_nums_new === null) {
                                            cell_lc_nums_new = null;
                                        } else {
                                            cell_lc_nums_new = JSON.stringify(cell_lc_nums_new)
                                                .replace(/,/g, ', ')
                                                .replace(/:/g, ': ');
                                        }

                                        if (differences == 0 && (new_cabinet_cd || cell_lc_nums_new || new_drawer_lc) && !new_device_cd) {
                                            note.push(t('not_found_differences') + `. `);
                                        }

                                        let cell_lc_nums_old = extractNumbers(old_cell);
                                        if (cell_lc_nums_old === null) {
                                            cell_lc_nums_old = null;
                                        } else {
                                            cell_lc_nums_old = JSON.stringify(cell_lc_nums_old)
                                                .replace(/,/g, ', ')
                                                .replace(/:/g, ': ');
                                        }

                                        listImportTempExcel.push({
                                            old_device_cd: old_device_cd,
                                            new_device_cd: new_device_cd,
                                            device_nm: device_nm,
                                            name_supplier: name_supplier,
                                            producer: producer,
                                            arrDepartments: arrDepartments,
                                            price: price,
                                            status_device:
                                                `${status_device}` === '0' || `${status_device}` === '1'
                                                    ? `${status_device}`
                                                    : '1',
                                            checking_after:
                                                `${status_device}` === '0'
                                                    ? moment()
                                                          .add(+checking_after ? +checking_after : 1, 'months')
                                                          .format('YYYYMMDD')
                                                    : '',
                                            can_grinding: can_grinding,
                                            old_cabinet_cd: old_cabinet_cd,
                                            old_drawer_lc: old_drawer_lc,
                                            cell_lc_nums_old: cell_lc_nums_old,
                                            new_cabinet_cd: new_cabinet_cd,
                                            new_drawer_lc: new_drawer_lc,
                                            cell_lc_nums_new: cell_lc_nums_new,
                                            arrProperties: arrProperties,
                                            note: note,
                                        });
                                    } else if (user?.length <= 15 && user?.length > 0) {
                                        setTimeout(() => {
                                            toast.error(`${t('row_data')}${idx} ${t('invalid')}`);
                                        }, idx * 100 + 1000);
                                    }
                            });
                            importExcelDeviceLocation([listImportTempExcel, idGroup]);
                            setVisibleExcel(true);
                        } else {
                            toast.error(t('data_file_err'));
                        }
                    } else {
                        toast.error(t('file_excel_err'));
                    }
                    // In ra dữ liệu từ file Excel
                };

                reader.readAsArrayBuffer(file);
            } catch (error) {
                console.log(error);
            }
        } else {
            toast.error(t('file_excel_err'));
        }
        fileInputRef.current.value = '';
    };
    const importExcelDeviceLocation = (data) => {
        sendRequest(
            serviceList.importTempListDeviceLocation,
            data,
            importExcelDeviceLocationResult,
            true,
            timeOutImport,
            600000
        );
    };
    const importExcelDeviceLocationResult = (reqInfoMap, message) => {
        setCheckDataExcel(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error(message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows[0].o_1;
            setDataExcel(data);
            dataLengthRef.current = data.length;
            setVisibleExcel(true);
        }
    };
    const timeOutImport = (reqInfo) => {
        setCheckDataExcel(false);
    };
    return {
        dataExcel,
        checkDataExcel,
        setDataExcel,
        handleFileUploadLocationDeviceProperty,
    };
};

export default useUploadFileLocationHook;
